






































import Vue, { PropType } from 'vue'
import XIcon, { IconProps } from '../Icon/XIcon.vue'
import sizeable, { Size } from '@/mixin/sizeable'

type Props = {
  size?: Size
  color?: string
  textColor?: string
  prependIcon?: IconProps
  appendIcon?: IconProps
  close?: boolean
  outlined?: boolean
  label?: boolean
}

export type ChipProps = Props

/**
 * @see https://material.io/components/chips#specs
 */
export default Vue.extend<{}, {}, {}, Props>({
  components: { XIcon },
  inheritAttrs: false,
  name: 'XChip',
  mixins: [sizeable],
  props: {
    prependIcon: {
      type: Object as PropType<IconProps>,
      required: false,
    },
    appendIcon: {
      type: Object as PropType<IconProps>,
      required: false,
    },
    close: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    label: {
      type: Boolean,
      default: false,
    },
    textColor: {
      type: String,
      required: false,
      default: 'white',
    },
  },
})
